import React from 'react';
import { 
  HelpCircle, 
  CreditCard, 
  Clock, 
  Percent, 
  FileText, 
  Shield, 
  Zap, 
  TrendingUp 
} from 'lucide-react';

const TipsSidebar = () => {
  const tips = [
    {
      icon: CreditCard,
      title: 'Выбор кредита',
      description: 'Сравнивайте предложения разных банков, учитывая полную стоимость кредита.'
    },
    {
      icon: Clock,
      title: 'Срок кредита',
      description: 'Чем короче срок, тем меньше переплата. Но monthly платеж будет выше.'
    },
    {
      icon: Percent,
      title: 'Процентная ставка',
      description: 'Обратите внимание на полную стоимость кредита, а не только на номинальную ставку.'
    },
    {
      icon: FileText,
      title: 'Документы',
      description: 'Подготовьте все необходимые справки и документы заранее.'
    },
    {
      icon: Shield,
      title: 'Страхование',
      description: 'Оцените необходимость страхования. Это может снизить ставку, но увеличит расходы.'
    },
    {
      icon: Zap,
      title: 'Досрочное погашение',
      description: 'Узнайте условия досрочного погашения. Некоторые банки взимают комиссию.'
    },
    {
      icon: TrendingUp,
      title: 'Платежеспособность',
      description: 'Ежемесячный платеж не должен превышать 30-40% вашего дохода.'
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <HelpCircle className="w-5 h-5 mr-2 text-indigo-500" />
        Советы по кредитованию
      </h3>

      <div className="space-y-3">
        {tips.map((tip, index) => (
          <div 
            key={index} 
            className="flex items-start space-x-3 p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <tip.icon className="w-5 h-5 text-indigo-500 mt-1 flex-shrink-0" />
            <div>
              <h4 className="text-sm font-medium text-gray-900 dark:text-white mb-1">
                {tip.title}
              </h4>
              <p className="text-xs text-gray-600 dark:text-gray-400">
                {tip.description}
              </p>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 border border-blue-100 dark:border-blue-800 rounded-lg">
        <div className="flex items-start space-x-3">
          <HelpCircle className="w-5 h-5 text-blue-500 mt-1 flex-shrink-0" />
          <div>
            <h4 className="text-sm font-semibold text-blue-700 dark:text-blue-300 mb-2">
              Бесплатная консультация
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400 mb-3">
              Всегда советуйтесь с финансовым специалистом перед принятием решения о кредите.
            </p>
            <button className="w-full py-1.5 text-xs bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors">
              Найти консультанта
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TipsSidebar;